import confet_sound from "./small-victory.mp3";
import ball_sound from "./ball.wav";

// Создание аудио-объектов
const confetSound = new Audio(confet_sound);
const ballSound = new Audio(ball_sound);
confetSound.volume=0.2;
ballSound.volume=0.2;
// Экспорт констант
export { confetSound, ballSound };